function HomePage() {
  const bannerSrc = `${process.env.PUBLIC_URL}/img/main-banner.png`;

  return (
    <div className="home">
      <div className="home-banner">
        <img
          src={bannerSrc}
          alt="산업 현장 이미지"
          className="home-banner__img"
        />
        <div className="home-banner__copy">
          <h1 className="home-banner__headline">안전도우미의 선두주자</h1>
          <p className="home-banner__subheadline">세진건설안전</p>
        </div>
      </div>
      <section>
        <div className="home-banner-sub">
          <img 
              src={`${process.env.PUBLIC_URL}/img/sejin_info.png`} 
              alt="세진건설안전" 
              className="home-banner-sub__info"
            />
          <img 
            src={`${process.env.PUBLIC_URL}/img/sub-banner1.png`} 
            alt="ve-2.5kg 소화기 (주)비전 Eng 공식 대리점(세진건설안전)" 
          />
          <img 
              src={`${process.env.PUBLIC_URL}/img/sejin_info.png`} 
              alt="세진건설안전"
              className="home-banner-sub__info"
            />
        </div>
      </section>
    </div>
  );
}

export default HomePage;
